import { render, staticRenderFns } from "./PrivateOrders.vue?vue&type=template&id=7493994c&"
import script from "./PrivateOrders.vue?vue&type=script&lang=js&"
export * from "./PrivateOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports